import { BooleanChip, BooleanOptionsMenu, LabelValue } from '@retail/components';
import React from 'react';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  mandatory: boolean;
  onSave?: (mandatory: boolean) => void;
}

export const CampaignMandatory = ({ mandatory, onSave }: Props) => {
  const t = useCampaignTFunction();

  return (
    <LabelValue
      label={t('campaign.columns.mandatory')}
      value={
        onSave ? (
          <BooleanOptionsMenu
            value={mandatory}
            onEdit={onSave}
            labelTrue={t('campaign.columns.mandatory')}
            labelFalse={t('campaign.columns.notMandatory')}
          />
        ) : (
          <BooleanChip
            value={mandatory}
            label={mandatory ? t('campaign.columns.mandatory') : t('campaign.columns.notMandatory')}
          />
        )
      }
      orientation="vertical"
      spacing={0.5}
    />
  );
};
